// extracted by mini-css-extract-plugin
export default {"recos":"Z2-z","productCardOverride":"_2-z","rowHasBadge":"a3-z"};